import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import KsDLCoAService from '../../../../../service/KsDLCoAService';
import KsDLCoAModal from './KsDLCoAModal';
import '../UtilityView.css';

class KsDLCoA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submissions: [],
      rows: [],
      headers: [],
    };
    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'transactionId',
        display: 'Transaction ID',
      },
      {
        value: 'driversLicenseNumber',
        display: 'Drivers License Number',
      },
    ];
  }

  state = undefined;

  onRowSelect(row) {
    this.setState({
      selectedSubmission: row,
    });
  }

  getSubmissionActivity(event) {
    const { search, combo, } = event;
    this.reset();
    const vm = this;
    const rows = [];
    let headers = [];

    const criteria = {};
    criteria[combo.value] = search.value;

    const allowedKeys = [
      'id',
      'customerId',
      'transactionId',
      'driversLicenseNumber',
      'createdOn',
    ];

    KsDLCoAService.getSubmissionsBySearchCriteria(criteria)
      .then((response) => {
        const { submissions, } = response.data;
        this.setState({ submissions, });
        if (submissions.length > 0) {
          headers = allowedKeys.map(header => ({
            value: header,
            display: _.startCase(header),
          }));

          submissions.forEach((submission) => {
            const filtered = {};
            filtered.id = submission.id;
            filtered.customerId = submission.customerId;
            filtered.transactionId = submission.submission.TransactionId;
            filtered.driversLicenseNumber = submission.submission.DLNum;
            filtered.createdOn = moment(submission.createdOn).utc().format();

            const row = Object.values(filtered);

            rows.push({ value: row, });
          });
          vm.setState({
            headers,
            rows,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay(submission) {
    if (!submission) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${submission.id}`}</p>
        <hr />
        <KsDLCoAModal submission={submission} />
      </div>
    );
  }

  reset() {
    this.setState({
      submissions: [],
      selectedSubmission: null,
      headers: [],
      rows: [],
    });
  }

  render() {
    const {
      submissions,
      headers,
      rows,
      selectedSubmission,
    } = this.state;
    const style = {
      maxHeight: '400px',
      overflowY: 'auto',
    };
    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.getSubmissionActivity(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Submissions" style={style}>
            <Grid
              headers={headers}
              rows={rows}
              onRowSelect={row => this.onRowSelect(submissions.find(x => x.id === row.id))}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedSubmission)}
        </div>
      </div>
    );
  }
}

export default KsDLCoA;
